module.exports = __webpack_public_path__ + "static/media/BoundWorx_Easy_Trowel_Data_Sheet.bbc7f026.pdf";